<template>
	<el-drawer :title="data && data.status === 2 ? '重传发票' : '上传发票'" :visible.sync="drawerShow" :wrapperClosable="false"
		:destroy-on-close="true" size="540px" @close="close">
		<div class="drawer-content">
			<!-- 发票信息描述列表 -->
			<el-descriptions v-if="data" :column="1" border size="small" title="发票信息">
				<el-descriptions-item label="订单编号">{{ data.orderSn }}</el-descriptions-item>
				<el-descriptions-item label="发票抬头类型">{{ data.titleType }}</el-descriptions-item>
				<el-descriptions-item label="发票抬头">{{ data.title }}</el-descriptions-item>
				<!-- 个人类型税号字段存的是身份证号，标签相应切换 -->
				<el-descriptions-item :label="data.titleType == '个人' ? '身份证号' : '税号'">{{ data.taxNumber }}</el-descriptions-item>
				<el-descriptions-item label="开票金额">{{ data.amount }}</el-descriptions-item>
				<el-descriptions-item label="发票类型">{{ data.typeView }}</el-descriptions-item>
				<el-descriptions-item label="用户邮箱">{{ data.email }}</el-descriptions-item>
			</el-descriptions>
			<el-form :model="formData" ref="formData" label-position="top" class="MT10">
				<el-form-item prop="filePath" label="上传发票:" :rules="[{ required: true, message: '请上传发票' }]">

					<image-upload :url.sync="relFilePath" :urlFull.sync="filePath"
						accept="image/png, image/jpeg, image/gif, application/pdf, application/ofd" :bytes="2"
						@onSuccess="handleUploadSuccess">
						<div slot="tips">上传后展示发票预览，并在下方给出校验结果</div>
					</image-upload>

					<!-- <el-upload class="upload-demo" drag action="" :show-file-list="false"
						accept="image/png, image/jpeg, image/gif, application/pdf, application/ofd"
						:http-request="handleUpload" :before-upload="beforeUpload" :disabled="uploading">
						<div class="upload-inner">
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">选择 PDF/OFD/图片发票</div>
							<div class="upload-tip">上传后展示发票预览，并在下方给出校验结果</div>
						</div>
					</el-upload> -->
					
				</el-form-item>

				<div v-if="ocrLoading" class="ocr-loading-wrap">
					<i class="el-icon-loading"></i> 正在识别发票信息...
				</div>

				<!-- 发票预览卡片 -->
				<div v-if="ocrResult" class="invoice-preview-card">
					<div class="preview-header">
						<div class="preview-file">{{ ocrResult.fileName || '' }}</div>
						<el-tag size="small" type="info">{{ ocrResult.invoiceTypeDesc || '电子发票' }}</el-tag>
					</div>
					<div class="preview-info">
						<div class="info-grid two-col">
							<div class="info-cell">
								<span class="info-label">发票号码</span>
								<span class="info-text">{{ ocrResult.invoiceNumber || '-' }}</span>
							</div>
							<div class="info-cell">
								<span class="info-label">开票日期</span>
								<span class="info-text">{{ formatDate(ocrResult.invoiceDate) || '-' }}</span>
							</div>
						</div>
						<div class="info-grid two-col">
							<div class="info-cell">
								<span class="info-label">购买方</span>
								<span class="info-text">{{ ocrResult.purchaserName || ocrResult.title || '-' }}</span>
							</div>
							<div class="info-cell">
								<span class="info-label">开票金额</span>
								<span class="info-text amount">¥{{ ocrResult.amount || '-' }}</span>
							</div>
						</div>
						<div class="info-grid">
							<div class="info-cell full">
								<span class="info-label">销售方</span>
								<span class="info-text">{{ ocrResult.sellerName || '-' }}</span>
							</div>
						</div>
					</div>
					<!-- 校验结果提示 -->
					<div v-if="ocrResult.matchStatus === 1" class="ocr-tip success">
						<i class="el-icon-circle-check"></i> 校验通过，可提交
					</div>
					<div v-else-if="ocrResult.matchStatus === 2" class="ocr-tip warning">
						<i class="el-icon-warning"></i> {{ ocrResult.matchStatusDesc || '待处理' }}
					</div>
					<div v-else-if="ocrResult.matchStatus === 3" class="ocr-tip danger">
						<i class="el-icon-circle-close"></i> {{ ocrResult.failureReason || ocrResult.matchStatusDesc ||
						'校验未通过' }}
					</div>
				</div>
				<div class="MT20" v-if="formData.filePath">
					<el-button size="mini" round type="primary" plain 
						@click="downloadInvoice()" :loading="downLoading">下载发票</el-button>
				</div>
			</el-form>
		</div>
		<div class="drawer-footer">
			<el-button @click="close">取消</el-button>
			<el-button v-if="ocrResult" type="primary" @click="submitForm()" :loading="btnLoading"
				:disabled="ocrResult.matchStatus != 1">提交</el-button>
		</div>
	</el-drawer>
</template>

<script>
import {
	downloadFile,
} from '@/assets/js/commonApi.js';
import ImageUpload from '@/components/ImageUpload/index.vue'
const defaultFormData = {
	filePath: '',
}
export default {
	components: { ImageUpload },
	data() {
		return {
			drawerShow: false, // 上传发票抽屉是否显示
			btnLoading: false, // 提交按钮加载状态
			data: null, // 当前发票数据
			formData: {
				...defaultFormData
			},
			downLoading: false, // 下载按钮加载状态
			ocrLoading: false, // OCR 识别加载状态
			ocrResult: null, // OCR 识别结果

			relFilePath: '', // 上传成功后的文件相对路径（用于 OCR 识别）
			filePath: '', // 上传成功后的文件完整路径（用于下载）
		}
	},
	
	methods: {
		//关闭抽屉时重置数据
		close() {
			this.drawerShow = false;
			this.formData = {
				...defaultFormData
			};
			this.data = null;
			this.downLoading = false;
			this.ocrLoading = false;
			this.ocrResult = null;
			this.relFilePath = '';
			this.filePath = '';
		},
		//打开抽屉时初始化数据
		show(data) {
			this.data = data;
			this.formData = {
				...defaultFormData,
				filePath: this.data && this.data.relFilePath || '',
			}
			this.filePath = this.data?.filePath || '';
			this.relFilePath = this.data?.relFilePath || '';

			this.drawerShow = true;

			this.$nextTick(() => {
				this.$refs.formData.clearValidate();
			});
		},
		//下载发票
		async downloadInvoice() {
			this.downLoading = true;
			try {
				//下载地址：优先上传后记录的地址，其次回显恢复的完整地址，最后取行数据
				var fileUrl = this.relFilePath || this.filePath || '';
				var suffix = this.$utils.getFileType(fileUrl);
				var fileName = (this.data?.orderSn || '-') + '.' + suffix;
				await downloadFile(fileUrl, fileName);
			} catch (error) {
				this.$message.error('下载失败');
				console.error(error);
			} finally {
				this.downLoading = false;
			}
		},
		//格式化日期为 YYYY-MM-DD 格式
		formatDate(dateStr) {
			if (!dateStr) return '';
			const s = String(dateStr);
			if (s.length === 8) {
				return `${s.slice(0, 4)}-${s.slice(4, 6)}-${s.slice(6, 8)}`;
			}
			return s;
		},
		submitForm() {
			this.$refs["formData"].validate((valid) => {
				if (valid) {
					this.btnLoading = true
					// id 从 OCR 结果的候选项中取
					let recordId = this.data ? this.data.id : '';
					if (this.ocrResult && this.ocrResult.candidates && this.ocrResult.candidates.length > 0) {
						recordId = this.ocrResult.candidates[0].id;
					}
					this.$request({
						url: "/invoice/record/upload",
						method: "post",
						params: {
							filePath: this.formData.filePath,
							id: recordId,
						},
					})
						.then((res) => {
							const {
								state,
								msg
							} = res.data;
							if (state == 1) {
								this.$message.success("操作成功");
								this.$emit('onUpdate');
								this.close();
							} else {
								this.$message.error(msg || "操作失败");
							}
						})
						.catch(() => {
							this.$message.error("操作失败");
						})
						.finally(() => {
							this.btnLoading = false;
						});

				} else {
					return false;
				}
			});
		},

		async handleUploadSuccess() {
			this.formData.filePath = this.relFilePath;
			this.$refs["formData"].validateField("filePath");
			this.ocrLoading = true;
			const ocrRes = await this.$request({
				url: '/invoice/record/ocrAndMatch',
				method: 'post',
				data: {
					fileUri: this.filePath,
					invoiceType: this.data.type,
					startUserId: this.data.startUserId,
					goodsId: this.data.goodsId,
					sessionId: this.data.sessionId,
					id: this.data?.id || '',
				},
			}).catch(() => {
				return this.$message.error('识别请求失败');
			});
			const { state, msg, result } = ocrRes.data;
			if (state == 1 && result) {
				this.ocrResult = result;
			} else {
				this.$message.error(msg || '识别失败');
			}
			this.ocrLoading = false;
		}
	}
}
</script>

<style lang="scss" scoped>
/* OCR 加载状态 */
.ocr-loading-wrap {
	text-align: center;
	padding: 16px;
	color: #409EFF;
	font-size: 14px;

	i {
		margin-right: 6px;
	}
}

/* 上传成功后的文件预览 */
// .file-preview-wrap {
// 	margin-top: 12px;
// 	border: 1px solid #e4e7ed;
// 	border-radius: 6px;
// 	padding: 10px;
// 	background: #fafafa;

// 	// pdf 每页之间留出间隔
// 	.preview-pdf {
// 		width: 100%;
// 		margin-bottom: 10px;

// 		&:last-child {
// 			margin-bottom: 0;
// 		}
// 	}
// }

/* 发票预览卡片 */
.invoice-preview-card {
	border: 1px solid #e4e7ed;
	border-radius: 6px;
	background: #fff;
	margin-top: 12px;
	overflow: hidden;

	.preview-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 16px;
		background: #fafafa;
		border-bottom: 1px solid #ebeef5;

		.preview-file {
			font-size: 14px;
			color: #606266;
			word-break: break-all;
			flex: 1;
			margin-right: 12px;
		}
	}

	.preview-info {
		padding: 16px;

		.info-grid {
			display: flex;
			margin-bottom: 12px;

			&:last-child {
				margin-bottom: 0;
			}

			.info-cell {
				flex: 1;
				min-width: 0;

				&.full {
					flex: none;
					width: 100%;
				}

				.info-label {
					display: block;
					font-size: 12px;
					color: #909399;
					margin-bottom: 4px;
				}

				.info-text {
					display: block;
					font-size: 14px;
					color: #303133;
					word-break: break-all;
					line-height: 1.4;

					&.amount {
						font-size: 16px;
						font-weight: 600;
						color: #f56c6c;
					}
				}
			}
		}
	}

	.ocr-tip {
		margin: 0 16px 12px;
		padding: 8px 12px;
		border-radius: 4px;
		font-size: 13px;
		line-height: 1.4;

		i {
			margin-right: 4px;
		}

		&.success {
			background: #f0f9eb;
			color: #67c23a;
		}

		&.warning {
			background: #fdf6ec;
			color: #e6a23c;
		}

		&.danger {
			background: #fef0f0;
			color: #f56c6c;
		}
	}

	// .preview-footer {
	// 	padding: 0 12px 10px;
	// 	text-align: right;
	// }
}
</style>